import { npcLogConstant } from './constant';

export const getNpcEntries = (payload: any) => {
  return {
    type: npcLogConstant.GET_NPC_ENTRIES_REQUEST,
    payload,
  };
};

export const getNpcActivityTypes = () => {
  return {
    type: npcLogConstant.GET_NPC_ACTIVITY_TYPES_REQUEST,
  };
};

export const addNpcEntryAction = (payload: any) => {
  return {
    type: npcLogConstant.ADD_NPC_ENTRY_REQUEST,
    payload,
  };
};

export const editNpcEntryAction = (payload: any) => {
  return {
    type: npcLogConstant.EDIT_NPC_ENTRY_REQUEST,
    payload,
  };
};

export const deleteNpcEntryAction = (payload: any) => {
  return {
    type: npcLogConstant.DELETE_NPC_ENTRY_REQUEST,
    payload,
  };
};

export const resetAddNpcEntryAction = () => {
  return {
    type: npcLogConstant.ADD_NPC_ENTRY_RESET,
  };
};

export const resetEditNpcEntryAction = () => {
  return {
    type: npcLogConstant.EDIT_NPC_ENTRY_RESET,
  };
};

export const resetDeleteNpcEntryAction = () => {
  return {
    type: npcLogConstant.DELETE_NPC_ENTRY_RESET,
  };
};

// ── Reviewer surface (THIN-7742) ──
export const getNpcTeamEntries = (payload: any) => {
  return {
    type: npcLogConstant.GET_NPC_TEAM_ENTRIES_REQUEST,
    payload,
  };
};

export const getNpcTeamEntriesEditable = (payload: any) => {
  return {
    type: npcLogConstant.GET_NPC_TEAM_ENTRIES_EDITABLE_REQUEST,
    payload,
  };
};

// payload: { id, action: 'approve' | 'decline' | 'reopen', declineReason? }
export const reviewNpcEntryAction = (payload: any) => {
  return {
    type: npcLogConstant.REVIEW_NPC_ENTRY_REQUEST,
    payload,
  };
};

export const resetReviewNpcEntryAction = () => {
  return {
    type: npcLogConstant.REVIEW_NPC_ENTRY_RESET,
  };
};
